module.exports = __webpack_public_path__ + "img/blockS3-card5.70815c61.jpg";